// extracted by mini-css-extract-plugin
export default {"main":"Home_main__3ilkD"};